module.exports = __webpack_public_path__ + "static/img/89001A_1_R_20200819_LC.3cb53f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/89001A_1_R_20200819_LC.png
// module id = ST9y
// module chunks = 0